<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>Bewerk</ion-title>
        <ion-buttons slot="primary">
          <ion-button @click="addItem">
            <ion-icon slot="icon-only" name="add" size="large"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content fullscreen class="ion-padding">
      <items mode="edit" :image="this.croppedImage"></items>
    </ion-content>
  </div>
</template>
<script>
  import Items from '../components/Items';

  export default {
    name: 'edit',
    components: {
      Items,
    },
    data() {
      return {
        info: null,
        i: 0,
        croppedImage: 'https://ionicframework.com/docs/demos/api/card/madison.jpg',
      };
    },
    watch: {},
    methods: {
      addItem() {
        this.$router.push({ name: 'addItem' });
      }
    },
    created() {
    }
  };
</script>
